export default __webpack_public_path__ + "static/media/mobile-menu.68601a21.png";